export const currencyDecimalFilter = (value, currency, locale) => {
    const formatter = new Intl.NumberFormat(locale, {
        style: "decimal",
        currency: currency,
        minimumFractionDigits: 2
    });
    return formatter.format(value);
};
